import { Icon } from "@iconify/react/dist/iconify.js";

import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import toast from "react-hot-toast";
import { login } from "../../redux/authModalSlice";
import { setUserPasswordApi, signinApi } from "../../apiHelper/authService";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
// import logoImg from "../../src/assets/images/small_svg.svg"
const VerifyUser = () => {
    const { slug } = useParams()
    const navigate = useNavigate()
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch()
    const [error, setError] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);


    const [formData, setFormData] = useState({
        email: "",
        password: "",
        confirmPassword: ""
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        const updatedValue = name === "email" ? value.toLowerCase() : value;

        setFormData((prev) => ({
            ...prev,
            [name]: updatedValue,
        }));
    };

    const handleSignIn = async (e) => {

        e.preventDefault();
        setLoading(true);
        setError("");




        const toastId = toast.loading("Setting up password.....");

        try {
            const userData = await setUserPasswordApi({ password: formData?.password, confirm_password: formData?.confirmPassword, user_id: slug });


            // dispatch(login(userData));
            toast.success("All done! Your password is secured and your account is ready.", { id: toastId });
            navigate("/sign-in")
        } catch (err) {
            console.error("Login Error:", err);


            const errorMessage = err || "Failed to set up passowrd. Please try again.";

            toast.error(errorMessage, { id: toastId });
        } finally {
            setLoading(false);
        }
    }


    return (
        <section className='auth bg-base d-flex flex-wrap'>
            <div className='auth-left d-lg-block d-none'>
                <div className='d-flex align-items-center flex-column h-100 justify-content-center'>

                    <img src='assets/images/SignIn/banner_image_3.png' alt='' className="h-100 w-100" style={{ objectFit: "cover" }} />
                </div>
            </div>
            <div className='auth-right py-32 px-24 d-flex flex-column justify-content-center'>
                <div className='max-w-464-px mx-auto w-100'>
                    <div>
                        <Link to='/' className='mb-40 max-w-290-px d-flex ' style={{ marginLeft: "-20px" }}>
                            <img src='assets/images/webLogo/ship_logo.svg' alt='' />
                        </Link>
                        <h4 className='mb-12'>Create a Secure Password</h4>
                        <p className='mb-32 text-secondary-light text-lg'>
                            We’ve created your account. To activate it, please set a secure password to get started.
                        </p>
                    </div>
                    <form onSubmit={handleSignIn}>


                        <div className='position-relative mb-20'>
                            <div className='icon-field'>
                                <span className='icon top-50 translate-middle-y'>
                                    <Icon icon='solar:lock-password-outline' />
                                </span>
                                <input
                                    type={showPassword ? 'text' : 'password'}
                                    className='form-control h-56-px bg-neutral-50 radius-12'
                                    id='your-password'
                                    placeholder='Enter Password'
                                    value={formData?.password}
                                    onChange={handleChange}
                                    name="password"
                                />
                            </div>

                            <span
                                onClick={() => setShowPassword(prev => !prev)}
                                className='toggle-password cursor-pointer position-absolute end-0 top-50 translate-middle-y me-16 text-secondary-light'
                            >
                                <i className={showPassword ? 'ri-eye-off-line' : 'ri-eye-line'}></i>
                            </span>
                        </div>



                        <div className='position-relative mb-24'>
                            <div className='icon-field'>
                                <span className='icon top-50 translate-middle-y'>
                                    <Icon icon='solar:lock-password-outline' />
                                </span>
                                <input
                                    type={showConfirmPassword ? 'text' : 'password'}
                                    className='form-control h-56-px bg-neutral-50 radius-12'
                                    id='your-password'
                                    placeholder='Enter Confirm Password'
                                    value={formData?.confirmPassword}
                                    onChange={handleChange}
                                    name="confirmPassword"
                                />
                            </div>

                            <span
                                onClick={() => setShowConfirmPassword(prev => !prev)}
                                className='toggle-password cursor-pointer position-absolute end-0 top-50 translate-middle-y me-16 text-secondary-light'
                            >
                                <i className={showConfirmPassword ? 'ri-eye-off-line' : 'ri-eye-line'}></i>
                            </span>
                        </div>


                        <button
                            type='submit'
                            className='btn btn-primary text-sm btn-sm px-12 py-16 w-100 radius-12 '
                            disabled={loading}
                        >
                            {loading ? "Setting up..." : "Set Password"}
                        </button>
                    </form>
                </div>
            </div>
        </section>
    );
};

export default VerifyUser;
